import { axiosRequest } from "../client";
import { jsonToURLParam } from "../util";

let API_URL = 'https://bifrost.sandbox.usezapay.com.br';

if (process.env.REACT_APP_ENV === 'production') {
  API_URL = 'https://bifrost.usezapay.com.br';
}

const WalletService = {

  postDeposit: async ({ token, amount}) => {
    const { result } = await axiosRequest('POST', {
      host: API_URL,
      path: `/wallet/deposit`,
      data: { amount },
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao listar depósitos.',
      },
    });

    return result;
  },

  listDeposits: async ({ token, ...params }) => {
    const paramsUrl = jsonToURLParam(params);

    const { result } = await axiosRequest('GET', {
      host: API_URL,
      path: `/wallet/deposit${paramsUrl}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao listar depósitos.',
      },
    });

    if (!result.error) {
      return {
        ...result,
        data: result.data['deposits'] || [],
        pagination: result.data['pagination'],
      };
    }

    return result;
  },

  getBalance: async ({ token }) => {
    const { result } = await axiosRequest('GET', {
      host: API_URL,
      path: `/wallet/balance/`,
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao consultar saldo atual.',
      },
    });

    return result;
  },

  getNotification: async ({ token }) => {
    const { result } = await axiosRequest('GET', {
      host: API_URL,
      path: `/wallet/balance_notification/`,
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao consultar dados de notificação.',
      },
    });

    return result;
  },

  putNotification: async ({ token, email, amount }) => {
    const { result } = await axiosRequest('PUT', {
      host: API_URL,
      path: `/wallet/balance_notification/`,
      data: { 
        email,
        amount,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao atualizar dados de notificação.',
      },
    });

    return result;
  },
    
} 

export { WalletService };


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/services/axios.js